export default "__VITE_ASSET__BJ602ygn__"